import {Header} from "../../../../components/header";
// @ts-ignore
import globalStyle from "../style.module.scss";
import {Footer} from "../../../../components/footer";

export const AuspuffservicePage = () => {
    return (
        <>
            <Header/>

            <div className={globalStyle.detail_service}>
                <h1 className={globalStyle.headline}>Auspuffservice</h1>

                <div className={globalStyle.text_container}>
                    <p>Hören Sie auf Ihren Auspuff und lassen Sie auch kleine Defekte sofort beheben. Das erspart Ihnen
                        kostspielige Folgen.</p>
                </div>
            </div>

            <Footer/>
        </>
    )
}